import { styled } from "../../../../../../styles";

export const Container = styled("div", {
  // Hold a fixed side-panel width so the stages chart + stats keep a stable
  // size while leaving the bigger share of the tile to the main graph on the
  // left (which has min-width: 0 in the pinned tile, so its ResponsiveContainer
  // reflows to fill the rest). maxWidth/minWidth are the last-resort safety:
  // if the whole tile is narrower than this it clamps and reflows instead of
  // overflowing.
  width: "560px",
  maxWidth: "100%",
  minWidth: 0,
  flexShrink: 0,
  height: "100%",
  padding: "24px 32px 24px 40px",
  position: "relative",

  display: "flex",
  flexDirection: "column",

  // Divider from the graph when shown side-by-side inline, mirroring
  // SpirometrySection.
  borderLeft: "1px solid $gray-30",
});

export const Header = styled("div", {
  display: "flex",
  flexDirection: "column",
  marginBottom: "24px",
});

export const Title = styled("h2", {
  fontWeight: 500,
  fontSize: "$text-xl",
  lineHeight: "22px",
  color: "$black",
  margin: 0,
});

export const Subtitle = styled("span", {
  marginTop: "4px",
  color: "$gray-80",
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "16px",
});

export const Body = styled("div", {
  display: "grid",
  // The chart column needs a real minimum (not bare `1fr`, which is
  // `minmax(auto, 1fr)` and collapses to 0 when this panel is squeezed as a
  // flex item in the modal — the chart's ResponsiveContainer then renders
  // nothing). A min keeps it from collapsing in every context.
  gridTemplateColumns: "minmax(220px, 1fr) 180px",
  gap: "24px",
  alignItems: "flex-start",
});

export const StatsContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
});

export const StatsTitle = styled("div", {
  fontFamily: "$openSans",
  fontSize: "14px",
  fontWeight: 600,
  color: "$gray-100",
  marginBottom: "12px",
});

export const StatRow = styled("div", {
  display: "grid",
  gridTemplateColumns: "76px 1fr",
  padding: "6px 0",
  fontFamily: "$openSans",
  fontSize: "12px",
  color: "$gray-80",
});

export const StatLabel = styled("span", {
  display: "flex",
  alignItems: "center",
  gap: "6px",
});

export const StatSwatch = styled("span", {
  width: "8px",
  height: "8px",
  borderRadius: "50%",
});

export const StatValue = styled("span", {
  color: "#666",
  fontWeight: 500,
});

export const EmptyState = styled("div", {
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "$gray-80",
  fontSize: "14px",
  textAlign: "center",
  padding: "0 24px",
});
